import { PORTAL_THEMES, PortalThemeId } from '@shared/themes';
import { MatMenuItem } from '@angular/material/menu';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnInit,
  ViewChildren,
  QueryList,
  inject
} from "@angular/core";
import { environment } from "environments/environment";
import { AuthService } from "@shared/auth/auth.service";
import { MsalBroadcastService } from "@azure/msal-angular";
import { filter} from "rxjs/operators";
import { EventMessage, EventType } from "@azure/msal-browser";
import { Subscription} from "rxjs";
import { SharedService } from "@shared/services/shared.service";

@Component({
  selector: "app-navbar",
  host: {
    class: "matero-header",
  },
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class NavbarComponent implements OnInit {
  public titleFull = "Health Facility Licensing and Certification";
  public titleTablet = "Health Facility Licensing and Certification";
  public titleMobile = "HFLC";
  subscription !: Subscription;
  public environment = environment;
  @Input() showToggle = true;
  @Output() toggleSidenav = new EventEmitter<void>();

  private authService = inject(AuthService);
  public sharedService = inject(SharedService);
  private msalBroadcastService =  inject(MsalBroadcastService);

  ngOnInit(): void{
    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
    )
    .subscribe(() => {
      this.toggleSidenav.emit();
    });

    if(this.authService.isAuthenticated()) {
      this.authService.loadUserInformation();
      this.sharedService.setUserTheme();
    }
  }

  public get username(): string{
    return this.authService.username
  }

  login() {
    this.authService.login();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
  }

  readonly themeColumns = [
    { label: 'Light', themes: PORTAL_THEMES.filter(theme => theme.mode === 'light') },
    { label: 'Dark', themes: PORTAL_THEMES.filter(theme => theme.mode === 'dark') },
  ];
  @ViewChildren('themeOption') private themeOptions!: QueryList<MatMenuItem>;

  navigateTheme(event: KeyboardEvent, column: number, row: number): void {
    let targetColumn = column;
    let targetRow = row;
    switch (event.key) {
      case 'ArrowLeft': targetColumn = 0; break;
      case 'ArrowRight': targetColumn = 1; break;
      case 'ArrowUp': targetRow = (row + this.themeColumns[column].themes.length - 1) % this.themeColumns[column].themes.length; break;
      case 'ArrowDown': targetRow = (row + 1) % this.themeColumns[column].themes.length; break;
      default: return;
    }
    event.preventDefault();
    event.stopPropagation();
    targetRow = Math.min(targetRow, this.themeColumns[targetColumn].themes.length - 1);
    const offset = this.themeColumns.slice(0, targetColumn).reduce((total, group) => total + group.themes.length, 0);
    this.themeOptions.get(offset + targetRow)?.focus('keyboard');
  }

  selectTheme(id: PortalThemeId) {
    this.sharedService.userProfile.theme = id;
    this.sharedService.toggleTheme();
    if(this.isAuthenticated()){
      this.sharedService.updateUserProfileState();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
